import React from "react";

export const ClickHere = (props) => {
    return (
        <div className={`click-here enter-animation ${props.className}`}>
            <div>Click <a target="_blank" href="https://www.nature.com/articles/s41584-022-00798-0.pdf">here</a> to review the GRAPPA Guidelines. Novartis is one of the many corporate supporters of the GRAPPA network.</div>
            <div>GRAPPA, Group for Research and Assessment of Psoriasis and Psoriatic Arthritis.</div>
        </div>
    );
}